<template>
  <div
    class="w-[100vw] h-[100vh] fixed top-0 left-0 z-[9999] flex justify-center items-center bg-[#0000005a]"
  >
    <div
      class="w-[40vw] text-[var(--text)] gap-4 p-4 bg-[var(--fundoApp)] rounded-[10px] flex flex-col"
    >
      <div class="w-full flex gap-2 justify-between items-center">
        <h3 class="text-[#ff9b05]">Periodicidade</h3>
        <div class="flex gap-2 items-center">
          <HistoricoObjetoButton
            v-if="data.id"
            model-name="Periodicidade"
            :objeto-id="data.id"
            modelo-label="Periodicidade"
            icon-only
          />
          <AppButton
            class="text-[var(--text)]"
            v-bind:visibility="true"
            left_icon="fa-regular fa-circle-xmark fa-xl"
            emitType="close"
            @close="close"
            :width="23"
            :height="23"
          />
        </div>
      </div>

      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Familia:</label>
        <input
          :disabled="true"
          type="text"
          v-model="familia.nome"
          class="text-sm border border-[#ccc] p-1 rounded-md w-full"
          :class="{ 'input-required': !familia.id }"
        />
        <button
          v-if="data.id === 0"
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('familia')"
        ></button>
        <button
          v-if="data.id === 0"
          :style="{ color: 'red' }"
          @click="remove('familia')"
        >
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Serviço Atual:</label>
        <input
          :disabled="true"
          type="text"
          v-model="servico_a.nome"
          class="text-sm border border-[#ccc] p-1 rounded-md w-full"
          :class="{ 'input-required': !servico_a.id }"
        />
        <button
          v-if="data.id === 0"
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('servico_a')"
        ></button>
        <button
          v-if="data.id === 0"
          :style="{ color: 'red' }"
          @click="remove('servico_a')"
        >
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Serviço Seguinte:</label>
        <input
          :disabled="true"
          type="text"
          v-model="servico_b.nome"
          class="text-sm border border-[#ccc] p-1 rounded-md w-full"
          :class="{ 'input-required': !servico_b.id }"
        />
        <button
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('servico_b')"
        ></button>
        <button :style="{ color: 'red' }" @click="remove('servico_b')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Tempo:</label>
        <input
          :disabled="true"
          type="text"
          v-model="tempo"
          class="text-sm border border-[#ccc] p-1 rounded-md w-full"
        />
        <button
          class="fa-solid fa-pen-to-square text-2xl"
          :style="{ color: '#ff9b05' }"
          @click="open_dialog_alert('tempo')"
        ></button>
        <button :style="{ color: 'red' }" @click="remove('tempo')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <div class="flex gap-4 mt-4">
        <AppButton
          :padding="'var(--padding_btn)'"
          class="capitalize mb-auto"
          v-bind:visibility="true"
          :font_size="12"
          color="#ff9b05"
          left_icon="fa-solid fa-pen-to-square"
          text="Confirmar"
          emitType="select"
          @select="salvar_periodicidade"
        />

        <AppButton
          :padding="'var(--padding_btn)'"
          class="capitalize mb-auto"
          v-bind:visibility="true"
          :font_size="12"
          color="red"
          left_icon="fa-regular fa-rectangle-xmark"
          text="Cancelar"
          emitType="select"
          @select="close"
        />
      </div>
    </div>
  </div>

  <Dialog
    v-if="showDialog"
    :propsData="dialogProps"
    @close="closeDialog"
    @returnData="handleReturnData"
    :pagination="true"
    :multiSelectOptions="{ enabled: false, show_btn: false }"
  />

  <StaticMultiTable
    v-if="showStaticTable"
    :title="staticTable_title"
    :multiSelect="false"
    :data="StaticTableData"
    @returnData="handleReturnData"
    @close="showStaticTable = false"
  />
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import { toast } from "vue3-toastify";
import { data } from "autoprefixer";
import StaticMultiTable from "@/components/tables/multiSelectTable.vue";
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";

export default {
  components: {
    AppButton,
    Dialog,
    StaticMultiTable,
    HistoricoObjetoButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      id: 0,
      familia: { id: 0, nome: "" },
      servico_a: { id: 0, nome: "" },
      servico_b: { id: 0, nome: "" },
      tempo: 365,
      localinstalacao_id: 0,

      staticTable_title: "",

      currentType: null,

      dialogProps: {
        entity: [],
        sideBar: true,
        multi: false,
        queryParams: {  },
      },
      showDialog: false,

      currentType: "",

      showStaticTable: false,
      StaticTableData: [],
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    salvar_periodicidade() {
      if (!this.familia || this.familia.id === 0) {
        toast.error("Erro na familia", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }
      if (!this.servico_a || this.servico_a.id === 0) {
        toast.error("Erro no servico inicial", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }
      if (!this.servico_b || this.servico_b.id === 0) {
        toast.error("Erro no serviço final", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }
      if (!this.tempo) {
        toast.error("tem de ter tempo de periodicidade", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }

      let data = {
        id: this.id,
        localinstalacao_id: this.localinstalacao_id,
        familia: this.familia || "",
        servico_a: this.servico_a || "",
        servico_b: this.servico_b || [],
        tempo: this.tempo || "",
      };
      this.$emit("save", data);
    },

    retirar_filtro() {
      this.$emit("save", {});
    },

    open_dialog_alert(key) {
      if (key == "familia") {
        this.dialogProps.entity[0] = "familia";
        this.currentType = "familia";
        this.dialogProps.title = "familia";
        this.showDialog = true;
      } else if (key == "servico_a") {
        this.dialogProps.entity[0] = "tpservico";
        this.currentType = "tipoa";
        this.dialogProps.title = "tipoa";
        this.showDialog = true;
      } else if (key == "servico_b") {
        this.dialogProps.entity[0] = "tpservico";
        this.currentType = "tipob";
        this.dialogProps.title = "tipob";
        this.showDialog = true;
      } else if (key == "tempo") {
        this.StaticTableData = [
          { id: 1, nome: "15" },
          { id: 2, nome: "30" },
          { id: 3, nome: "60" },
          { id: 4, nome: "90" },
          { id: 5, nome: "180" },
          { id: 6, nome: "365" },
          { id: 7, nome: "1825" },
          { id: 8, nome: "3650" },
        ];
        this.staticTable_title = "tempo";
        this.showStaticTable = true;
      }
    },

    handleReturnData(data) {
      console.log("Returned data:", data);

      //this.status_concat = this.status_concat ? `${this.status_concat}, ${data.Status.nome}` : data.Status.nome;
      if (data.tipoa) {
        if (Array.isArray(data.tipoa)) {
          this.servico_a = data.tipoa[0];
        } else {
          this.servico_a = data.tipoa;
        }
      } else if (data.tipob) {
        if (Array.isArray(data.tipob)) {
          this.servico_b = data.tipob[0];
        } else {
          this.servico_b = data.tipob;
        }
      } else if (data.familia) {
        if (Array.isArray(data.familia)) {
          this.familia = data.familia[0];
        } else {
          this.familia = data.familia;
        }
      } else if (data.tempo) {
        if (Array.isArray(data.tempo)) {
          this.tempo = data.tempo[0].nome;
        } else {
          this.tempo = data.tempo.nome;
        }
      }
    },
    closeDialog() {
      this.showDialog = false;
    },

    remove(key) {
      if (key == "familia") {
        this.familia = { id: 0, nome: "" };
      } else if (key == "servico_a") {
        this.servico_a = { id: 0, nome: "" };
      } else if (key == "servico_b") {
        this.servico_b = { id: 0, nome: "" };
      } else if (key == "tempo") {
        this.tempo = 365;
      }
    },
  },

  computed() {
    toast.success("Computed", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000,
    });
  },

  created() {
    console.log(data);
  },

  watch: {
    data: {
      handler(val) {
        console.log("component Data:", val);
        if (val) {
          this.id = val.id;
          this.familia = val.familia;
          this.servico_a = val.servico_a;
          this.servico_b = val.servico_b;
          this.tempo = val.tempo;
          this.localinstalacao_id = val.localinstalacao_id;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
</style>
